import React from "react";
import RadioActive from "../../../../assets/icon/RadioActive";
import EfirControl from "../radioPlayer/fullScreenRadioPlayer/components/EfirControl";

interface Props {
  widthScreen?: string;
  widthProgress?: string;
  heightProgress?: string;
}

const ProgressBar: React.FC<Props> = ({
  widthScreen,
  widthProgress,
  heightProgress = "3px",
}) => {
  return (
    <>
      <div
        className="w-full min-w-[250px] "
        // style={{ width: widthScreen, height: heightProgress }}
      >
        <div className="flex items-center justify-center ">
          <RadioActive />
          <span className="pl-2 text-green font-semibold">RADIO ONLINE</span>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
